






















import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';

export default {
    name: 'LogoutAction',
    components: {
        CoCard,
        CoHeadline,
        CoText,
    },
    async mounted() {
        await this.$store.dispatch('logout').finally(() => {
            this.$router.push('/login');
        });
    },
};
